import { render, staticRenderFns } from "./SegundoNivel.vue?vue&type=template&id=6b35e6c4"
import script from "./SegundoNivel.vue?vue&type=script&lang=js"
export * from "./SegundoNivel.vue?vue&type=script&lang=js"
import style0 from "../main.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports